'use es6';

import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { InfoIcon } from 'foundations-assets';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ScriptedPropertyCell = renderArgs => {
  const {
    column
  } = renderArgs;
  const {
    align
  } = column;
  return /*#__PURE__*/_jsx("td", {
    children: /*#__PURE__*/_jsx(View, {
      textAlign: align,
      children: /*#__PURE__*/_jsx(Tooltip, {
        placement: "left",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-ui-components.scriptedPropertyCell.tooltip"
        }),
        children: /*#__PURE__*/_jsxs(Text, {
          as: "span",
          color: "text-primary-disabled",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-ui-components.scriptedPropertyCell.message"
          }), ' ', /*#__PURE__*/_jsx(InfoIcon, {})]
        })
      })
    })
  });
};
export default ScriptedPropertyCell;